import PlaceIcon from '@mui/icons-material/Place';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import CopyrightIcon from '@mui/icons-material/Copyright';
import ContactForm from '../components/ContactForm'


export default function Footer() {

    let footerData = [
        {
            icon: <PlaceIcon sx={{fontSize: "18px"}} />,
            text: "04070, Ukraine, Kyiv, str. Illinska 8, BizCenter \"ILLINSKY\", office 107"
        },
        // {
        //     icon: <PhoneIcon sx={{fontSize: "18px"}} />,
        //     text: "+38 050 673-18-47 (Mon-Fri 09:00 - 17:00 EET)"
        // },
        {
            icon: <EmailIcon sx={{fontSize: "18px"}} />,
            text: "acepim.com@gmail.com"
        }
    ]

    let contactElements = footerData.map((item: any, index: number) => {
        return <div key={index} className="contact-item">
            <div style={{margin: "2px 5px 0 0"}}>{item.icon}</div>
            <div style={{fontSize: "0.92rem"}}>{item.text}</div>
        </div>
        })

    return (

        <div className="footer-block" id="contacts">

            <div>
                <div className="footer-header">Let's get in touch!</div>

                <ContactForm />

            </div>

            <div>
                <div className="footer-header">Contact information</div>
                <div>{contactElements}</div>
            </div>


            <div className="footer-copyright">
                <div style={{paddingTop: "3px"}}><CopyrightIcon sx={{fontSize: "16px"}} /></div>
                <div>Acepim™ 2020-2026. All rights reserved.</div>
            </div>

        </div>
    )
}
